module.exports = __webpack_public_path__ + "img/complexe-sportif-claude-robillard.27eca4c4.webp";